import axiosInstance from './axiosInstance';

export const getTiers          = ()                    => axiosInstance.get('/Tier/GetTiers');
export const getMyTierStatus   = ()                    => axiosInstance.get('/Tier/MyStatus');
export const getUserTierStatus = (userId)              => axiosInstance.get(`/Tier/UserStatus?userId=${userId}`);
export const upsertTier        = (req)                 => axiosInstance.post('/Tier/UpsertTier', req);
export const getPendingPromos  = (stage = 'All')       => axiosInstance.get(`/Tier/Pending?stage=${stage}`);
export const approveAccountant = (promotionId)         => axiosInstance.post(`/Tier/ApproveAccountant?promotionId=${promotionId}`);
export const approveFinal      = (promotionId)         => axiosInstance.post(`/Tier/ApproveFinal?promotionId=${promotionId}`);
export const rejectPromotion   = (promotionId, reason) => axiosInstance.post(`/Tier/Reject?promotionId=${promotionId}`, { reason });
export const getCurrentTierBulk = (userIds) => {
  const qs = (userIds || []).map(id => `userIds=${id}`).join('&');
  return axiosInstance.get(`/Tier/CurrentTierBulk?${qs}`);
};

// Full status (revenue / next tier / progress %) for many users — same numbers as
// getUserTierStatus, used by the hierarchy cards' Sales Ranking bar.
export const getTierStatusBulk = (userIds) => {
  const qs = (userIds || []).map(id => `userIds=${id}`).join('&');
  return axiosInstance.get(`/Tier/StatusBulk?${qs}`);
};
